import React from 'react'
import NotFound from 'components/NotFound/NotFound'
import { getDocumentHead } from 'components/DocumentHead'

const NotFoundPage = (): React.ReactElement => <NotFound />

export default NotFoundPage

export const Head = getDocumentHead({ title: 'Not found' })
